import * as ActionTypes from '../actions/actionTypes'
import objectPath from 'object-path'

export default function reduce(state = {}, action)
{
    switch(action.type)
    {
        case ActionTypes.COPY_STATE_VALUE:
            let location = action.payload.location;
            let value = action.payload.value;
            let copy = Object.assign({}, state);

            objectPath.set(copy, location, value);

            return copy;

        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./node_modules/@alme/ui-web/modules/state-copier/src/reducers/index.js